import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNavStore = defineStore('nav', () => {
  const activeNav = ref('remove')
  const breadcrumbTitle = ref('抠图工作台')
  const pageTitle = ref('抠图工作台')
  const pageSub = ref('本地抠图或豆AI抠图 + 背景重绘')

  const syncFromRoute = (route) => {
    const meta = route?.meta || {}
    activeNav.value = meta.navKey || 'remove'
    breadcrumbTitle.value = meta.breadcrumb || meta.title || '抠图工作台'
    pageTitle.value = meta.title || breadcrumbTitle.value
    pageSub.value = meta.subTitle || ''
  }

  return {
    activeNav,
    breadcrumbTitle,
    pageTitle,
    pageSub,
    syncFromRoute
  }
})
